import { z } from "zod";

export const supplierSchema = z.object({
  id: z.number(),
  name: z.string(),
  address: z.string().nullable(),
});

export type Supplier = z.infer<typeof supplierSchema>;
